<script>
import * as THREE from 'three'
export default {
  abstract: true,
  render () {
    return null
  },
  data () {
    return {
      geometry: null
    }
  },
  created () {
    this.geometry = new THREE.SphereGeometry(2, 32, 32)
    // this.geometry
    this.$emit('geometry', this.geometry)
  },
  watch: {
  },
  mounted () {
    this.$parent.__add(this.geometry, 'geometry')
  },
  beforeDestroy () {
    this.$parent.__remove(this.geometry, 'geometry')
  }
}
</script>

<style scoped>
.box-geometry{
  display: none;
}
</style>



// WEBPACK FOOTER //
// SphereGeometry.vue?646d6092